import '../assets/styles/Contact.scss';

function Contact() {
  return (
    <div id="contact">
      <center>
        <div className="items-container">
          <div className="contact_wrapper">
            <h1>Contact Me</h1>
            <p>
              I'm currently looking for a graphics or engine programming internship / apprenticeship.
              Whether you want to talk about a project, an opportunity, or just
              low-level rendering, feel free to reach out.
            </p>
          </div>
        </div>
      </center>
    </div>
  );
}

export default Contact;